import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
    selector: 'app-variation-meli-popup',
    templateUrl: './variation-meli-popup.component.html',
    styleUrls: ['./variation-meli-popup.component.scss'],
    standalone: false
})
export class VariationMeliPopupComponent implements OnInit {


  @Input()itemselected = false;
  melidata:Object[];
  variation:{id:string, codeproduct:string}[] = [];

  formInicial:UntypedFormGroup;
  constructor(@Inject(NZ_MODAL_DATA) public dialogData, public dialogRef:NzModalRef<any>, public dialogService:DialogService) {


   }

  
  ngOnInit(): void {
      this.melidata = this.dialogData;
  
  }

  finalizar(event:Event){

    if ( this.variation.length != this.melidata.length){
      this.dialogService.openNewDialog("As variações não foram relacionadas. Deseja continuar a importação?",(data)=>{
          this.dialogRef.close(this.melidata);
      },()=>{
          this.dialogRef.close(false);
      })
    }else{
      this.dialogRef.close(this.melidata);
    }
     
  }
  
}
